import React from 'react';

/**
 * Renders `text` with all case-insensitive occurrences of `query` shown in <strong>.
 * Used to highlight which part of a suggestion matches what the user typed.
 *
 *   <HighlightMatch text="JavaScript" query="java" />
 *      → <strong>Java</strong>Script
 */
const HighlightMatch = ({ text, query }) => {
  if (!query) return <>{text}</>;
  const escaped = query.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  const re = new RegExp(`(${escaped})`, 'ig');
  const parts = text.split(re);
  const lowerQ = query.toLowerCase();
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === lowerQ ? (
          <strong key={i} className="font-semibold text-gray-900">{part}</strong>
        ) : (
          <span key={i} className="text-gray-600">{part}</span>
        )
      )}
    </>
  );
};

export default HighlightMatch;
